import React from "react";
import "../../assets/buttons.css";
import { withTranslation } from "react-i18next";

const buttonTypeMapping = (buttonType) => {
  let className = "";
  switch (buttonType) {
    case "regular_primary":
      className = "btn btn-primary";
      break;
    case "regular_success":
      className = "btn btn-success";
      break;
    case "regular_disabled":
      className = "btn disabled";
      break;
    case "regular_clear":
      className = "btn btn-clear";
      break;
    case "regular_link":
      className = "btn btn-link";
      break;
    case "regular_warning":
      className = "btn btn-warning";
      break;
    case "regular_danger":
      className = "btn btn-danger";
      break;
    case "small_primary":
      className = "btn-sm btn-default";
      break;
    default:
      className = "";
  }

  return className;
};

export const Button = (props) => {
  let className = buttonTypeMapping(props.buttonType);
  if (props.className) {
    className += " " + props.className;
  }
  const { showSpinner, disabled } = props;

  return (
    <button
      id={props.id}
      key={props.key}
      className={className}
      onClick={props.onClick ? props.onClick : (e) => { }}
      style={Object.assign({}, props.style)}
      disabled={disabled}
    >
      {showSpinner ? (
        <span
          className="spinner-border"
          style={{ width: "1.4rem", height: "1.4rem", borderWidth: ".2em" }}
          role="status"
          aria-hidden="true"
        ></span>
      ) : (
        ""
      )}
      <span
        className={showSpinner ? "leftMarginNormal" : ""}
        style={{ paddingTop: "2px" }}
      >
        {props.text}
      </span>
    </button>
  );
};

export const NavigationLinkButton = (props) => {
  return (
    <button
      id={props.id}
      key={props.key}
      className={
        (props.className ? props.className : "") + " appNavigationButton"
      }
      onClick={(e) => {
        e.preventDefault();
        if (props.onClick) props.onClick();
      }}
      style={Object.assign({}, props.style)}
    >
      <div>{props.text}</div>
    </button>
  );
};

export const LineSeperator = (props) => {
  const defaultStyle = {
    borderColor: "#0058a4"
  };

  return (
    <hr style={Object.assign(defaultStyle, props.style ? props.style : {})} />
  );
};

const ErrorComponent = ({ t, errorMessage, styles = {} }) => {
  return (
    <div style={styles}>
      <i
        aria-label={t("errors.hidden_error_msg")}
        className="fa fa-exclamation-circle error-indicator errorAlert errorMark"
        aria-hidden="true"
      />
      <span className="ns-visually-hidden">{t("errors.hidden_error_msg")}</span>
      <span style={{ marginLeft: "10px" }}>{errorMessage}</span>
    </div>
  );
};

export const ErrorWithString = withTranslation("common")(ErrorComponent);
